// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1e1j5","bigColWidth":"Table_bigColWidth__3rIYm","biggerColWidth":"Table_biggerColWidth__1HWVn","row":"Table_row__ipSKe","col":"Table_col__O0tNr"};